import React from 'react'
import { useHistory } from 'react-router-dom'
import cx from 'classnames'

import { makeStyles, useTheme } from '@material-ui/styles'
import { Drawer, Grid, Typography, IconButton, Button } from '@material-ui/core'
import { ArrowBack } from '@material-ui/icons'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import SearchIcon from '@material-ui/icons/Search'

import ImagePlaceholder from '~/components/ImagePlaceholder'
import { useLiterals } from '~/components/Literals'
import { mountUrl, replaceImagePath } from '~/utils'
import track from '~/track'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    height: '100%'
  },
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '16px 8px'
  },
  drawerMobile: {
    width: '100%',
    overflow: 'hidden',
    flexShrink: 0
  },
  drawerDesktop: {
    width: theme.gofind.asideWidth,
    overflow: 'hidden',
    flexShrink: 0
  },
  blurOnLoad: {
    filter: 'blur(5px)'
  },
  productImage: {
    height: 100,
    width: '100px !important',
    objectFit: 'contain',
    transition: '.3s ease'
  },
  productImageLoading: {
    height: 100,
    width: 100,
    filter: 'blur(5px)'
  },
  productItem: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    padding: 16,
    cursor: 'pointer'
  },
  productName: {
    fontSize: 24,
    ...theme.gofind.lineLimit(2)
  },
  button: {
    padding: '4px 0',
    height: 'fit-content',
    textTransform: 'lowercase',
    '&:hover': {
      background: 'none',
      textDecoration: 'underline'
    }
  },
  anyProduct: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}))

export default function DrawerProductByStore({ open, setOpen, products, isMobile }) {
  const classes = useStyles()
  const history = useHistory()
  const theme = useTheme()

  const { getLiteral } = useLiterals()

  function getSlug(value) {
    return value
      ?.toLowerCase()
      ?.replace(/\s+/g, '-')
      ?.replace(/[^a-z0-9-]/g, '')
  }

  function handleClose() {
    setOpen(false)
  }

  function handleRedirectAllProducts() {
    track('selecionarProduto', { category: 'menu', name: 'all' })

    history.push(`/produto/todos`)

    setOpen(false)
  }

  function handleRedirectProductDetails(product) {
    track('selecionarProduto', { category: 'menu', name: product?.name })

    history.push(`/produto/${getSlug(product?.name)}/${product?.gtin}`, {
      from: `${history.location.pathname}${history.location.search}`
    })

    setOpen(false)
  }

  function handleViewProductDetails(e, product) {
    e.preventDefault()
    e.stopPropagation()

    history.push(`/produto/${product.gtin}/detalhes`, {
      fromApp: true,
      prevPath: history.location.pathname
    })

    setOpen(false)
  }

  if (!products) return null

  return (
    <Drawer
      hideBackdrop
      id="drawer-list-products"
      anchor="left"
      open={open}
      onClose={handleClose}
      classes={{
        paper: cx(classes.paper, {
          [classes.drawerMobile]: isMobile,
          [classes.drawerDesktop]: !isMobile
        })
      }}
      PaperProps={{ 'data-cy': 'drawer-list-products' }}
      ModalProps={{
        container: document.getElementById('gofind-finder') || document.body,
        style: { position: 'absolute', width: isMobile ? '100%' : theme.gofind.asideWidth }
      }}
    >
      <Grid className={classes.content}>
        <IconButton aria-label={getLiteral('1051')} onClick={handleClose} size="small">
          <ArrowBack style={{ color: theme.palette.text.primary }} />
        </IconButton>

        <SimpleBar
          style={{
            maxHeight: '100%',
            width: '100%',
            overflow: 'auto'
          }}
        >
          <Grid className={classes.productItem} onClick={handleRedirectAllProducts}>
            <Grid className={classes.anyProduct} style={{ width: 100, height: 100 }}>
              <SearchIcon style={{ fontSize: 60, color: '#97A8AB' }} />
            </Grid>
            <Grid>
              <Typography variant="body1" className={classes.productName} style={{ width: '100%' }}>
                {`${getLiteral('1054')} ${getLiteral('1996').toLowerCase()}`}
              </Typography>
            </Grid>
          </Grid>

          {products?.map((product) => {
            const image = replaceImagePath(product)

            return (
              <Grid
                key={product.gtin}
                className={classes.productItem}
                onClick={() => handleRedirectProductDetails(product)}
              >
                <Grid style={{ width: 100, height: 100 }}>
                  {image ? (
                    <ImagePlaceholder
                      src={mountUrl(image, { width: 100, height: 100 })}
                      placeholder={mountUrl(image, { height: 100 })}
                    >
                      {(src, loading) => (
                        <img
                          data-cy="product-image"
                          src={src}
                          alt={product.name}
                          className={cx(classes.productImage, {
                            [classes.productImageLoading]: loading
                          })}
                        />
                      )}
                    </ImagePlaceholder>
                  ) : (
                    <Grid data-cy="product-without-image">{getLiteral('2030')}</Grid>
                  )}
                </Grid>

                <Grid>
                  <Typography variant="body1" className={classes.productName}>
                    {product.name}
                  </Typography>

                  <Button
                    variant="text"
                    endIcon={<ArrowForwardIosIcon style={{ fontSize: 12, color: '#97A8AB' }} />}
                    className={classes.button}
                    onClick={(e) => handleViewProductDetails(e, product)}
                  >
                    {getLiteral('2018')}
                  </Button>
                </Grid>
              </Grid>
            )
          })}
        </SimpleBar>
      </Grid>
    </Drawer>
  )
}
